import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

type BadgeProps = {
  greyScale?: boolean;
  text?: string;
};

const TippBadgeContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  align-items: center;
  text-align: center;
`;

export const Badge = styled.span<BadgeProps>`
  background: ${({ theme, greyScale }) => (greyScale ? theme.greyNormal.color.normal : '#9ec363')};
  color: ${({ theme, greyScale }) => (greyScale ? theme.greyNormal.color.text : '#fff')};
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.625rem;
  letter-spacing: 0.05rem;
  border-radius: 0.625rem;
  margin: 0 auto;
  padding: 0 0.75rem;
  height: 1rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  line-height: 1rem;
`;

export const TippBadge: FC<BadgeProps> = ({ greyScale = false, text = '' }) => (
  <TippBadgeContainer data-testid="tipp-badge-container">
    <Badge data-testid="tipp-badge" greyScale={greyScale}>
      {text !== '' ? text : <FormattedMessage id="utils.tipp-badge" defaultMessage="TIPP" />}
    </Badge>
  </TippBadgeContainer>
);

export function hexToRGB(hex: string, alpha?: number) {
  const newHex = hex.replace('#', '');
  const parsedR = newHex.substring(0, newHex.length / 3);
  const r = parseInt(parsedR.length === 1 ? `${parsedR}${parsedR}` : parsedR, 16);
  const parsedG = newHex.substring(newHex.length / 3, (2 * newHex.length) / 3);
  const g = parseInt(parsedG.length === 1 ? `${parsedG}${parsedG}` : parsedG, 16);
  const parsedB = newHex.substring((2 * newHex.length) / 3, (3 * newHex.length) / 3);
  const b = parseInt(parsedB.length === 1 ? `${parsedB}${parsedB}` : parsedB, 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
}

export const isClientSide = typeof window !== 'undefined';

export default TippBadge;
